module.exports = __webpack_public_path__ + "static/media/Feedbackbg@2x.6d185788.png";